import React from "react";

// Classic serif heritage monogram for Excelsior Consulting
// Renders crisply at any size; used in header and footer.
export const Logo = ({ variant = "dark", showWordmark = true, className = "" }) => {
  const ink = variant === "light" ? "#F7F5F0" : "#1F2326";
  const accent = "#901A1E";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg width="42" height="42" viewBox="0 0 64 64" aria-hidden="true">
        <rect x="1" y="1" width="62" height="62" fill="none" stroke={ink} strokeWidth="1.5" />
        <rect x="6" y="6" width="52" height="52" fill="none" stroke={ink} strokeWidth="0.6" />
        {/* Serif E */}
        <g fill={ink}>
          <rect x="18" y="16" width="28" height="3.6" />
          <rect x="18" y="16" width="3.8" height="32" />
          <rect x="18" y="28.6" width="22" height="3.4" />
          <rect x="18" y="44.4" width="28" height="3.6" />
          {/* Serifs */}
          <rect x="16.2" y="16" width="7.4" height="1.2" />
          <rect x="16.2" y="46.8" width="7.4" height="1.2" />
          <rect x="42" y="16" width="6" height="1.2" />
          <rect x="42" y="46.8" width="6" height="1.2" />
        </g>
        {/* Accent tick */}
        <rect x="42" y="28.6" width="6" height="3.4" fill={accent} />
      </svg>
      {showWordmark && (
        <div className="leading-none">
          <div
            className="font-serif tracking-[0.02em]"
            style={{ color: ink, fontSize: "1.25rem", fontWeight: 600 }}
          >
            Excelsior
          </div>
          <div
            className="font-mono"
            style={{
              color: ink,
              opacity: 0.7,
              fontSize: "0.62rem",
              letterSpacing: "0.32em",
              textTransform: "uppercase",
              marginTop: 2,
            }}
          >
            Consulting
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
